/**
 * DateSocialShareView — bloco de data + compartilhamento social.
 *
 * Exibe a data de publicação/modificação do conteúdo e botões de
 * compartilhamento nas redes sociais. Ambas as seções podem ser
 * ocultadas individualmente via configuração do bloco.
 */
import { defineMessages, FormattedDate, useIntl } from 'react-intl';
import ShareButtons from '../../News/ShareButtons/ShareButtons';

const messages = defineMessages({
  published: {
    id: 'dateSocialShare.published',
    defaultMessage: 'Published',
  },
});

interface DateSocialShareData {
  hideDate?: boolean;
  hideShare?: boolean;
}

interface DateSocialShareViewProps {
  data: DateSocialShareData;
  properties: {
    '@id'?: string;
    effective?: string;
    modified?: string;
    created?: string;
  };
}

const DateSocialShareView = ({
  data = {},
  properties,
}: DateSocialShareViewProps) => {
  const intl = useIntl();
  const { hideDate = false, hideShare = false } = data;

  const dateStr =
    properties?.effective || properties?.modified || properties?.created;

  if (hideDate && hideShare) return null;

  return (
    <div className="date-social-share-block">
      <hr className="date-social-share-block__divider" />
      <div className="date-social-share-block__inner">
        {!hideDate && dateStr && (
          <span className="date-social-share-block__date">
            <span className="date-social-share-block__date-label">
              {intl.formatMessage(messages.published)}:
            </span>{' '}
            <FormattedDate
              value={dateStr}
              day="2-digit"
              month="long"
              year="numeric"
            />
          </span>
        )}
        {!hideShare && (
          <ShareButtons
            url={properties?.['@id']}
            className="date-social-share-block__share"
          />
        )}
      </div>
      <hr className="date-social-share-block__divider" />
    </div>
  );
};

export default DateSocialShareView;
